/* eslint-disable no-underscore-dangle, import/prefer-default-export */
import config from 'universal-config';
import { deepExtract } from 'helpers/deep';

function experimentById(experimentId) {
  try {
    return window.optimizely.get('state').getExperimentStates()[experimentId];
  } catch (err) {
    /* NOOP */
  }
}

function experimentByName(experimentName) {
  try {
    const userState = window.optimizely.get('state').getExperimentStates();
    return Object.values(userState).find(experiment => (experiment.experimentName || '').startsWith(experimentName));
  } catch (err) {
    /* NOOP */
  }
}

export const trackOptimizelyEvent = (name, metadata = null) => {
  /* istanbul ignore next */
  if (__CLIENT__) {
    window.optimizely = window.optimizely || [];
    window.optimizely.push(['trackEvent', name, metadata].filter(Boolean));
  }
};

export const getCohortForExperiment = experimentPrefix => {
  const experiment = experimentByName(experimentPrefix) || {};
  if (experiment?.isActive) {
    return {
      test_id: experiment.id,
      variant_id: experiment.variation.id,
      experiment_name: experiment.experimentName,
      variation_name: experiment.variation.name,
      test_branch: `${experiment.experimentName}: ${experiment.variation.name}`,
    };
  }
};

export const getUserExperimentVariationMap = () => {
  try {
    const userState = window.optimizely.get('state').getExperimentStates();
    return Object.values(userState)
      .filter(({ variation }) => variation)
      .reduce((memo, { experimentName, variation }) => {
        memo[experimentName] = variation.name;
        return memo;
      }, {});
  } catch (err) {
    return {};
  }
};

export function isActiveExperimentById(experimentId) {
  const experiment = experimentById(experimentId) || {};
  return !!experiment.isActive;
}

export function isActiveExperimentByName(experimentName) {
  const experiment = experimentByName(experimentName) || {};
  return !!experiment?.isActive;
}

export function isActiveVariationById(experimentId, variationId) {
  const experiment = experimentById(experimentId) || {};
  return !!(experiment.isActive && experiment.variation.id === variationId);
}

export function isActiveVariationByName(experimentName, variationName) {
  const experiment = experimentByName(experimentName) || {};
  return !!(experiment?.isActive && experiment?.variation.name === variationName);
}

export function isActiveVariationFromConfig(configName) {
  const experiment = deepExtract(`optimizely.experiments.${configName}`, config(), {});
  return isActiveVariationById(experiment.id, experiment.variationId);
}

// If the visitor is excluded from an Experiment due to traffic allocation, the Experiment is considered
// active and they will be bucketed into a variation, but no visual changes will be applied.
// https://developers.optimizely.com/x/solutions/javascript/reference/
export function isUserExcludedFromExperimentByName(experimentName) {
  const experiment = experimentByName(experimentName);
  if (experiment?.isActive) {
    return experiment.isInExperimentHoldback;
  }
}

export function isUserExcludedFromExperimentById(experimentId) {
  const experiment = experimentById(experimentId);
  if (experiment?.isActive) {
    return experiment.isInExperimentHoldback;
  }
}
